export default new class SmoothScroll {
    init() {
		this.initSmoothScroll();
	}

    initSmoothScroll() {

		// When clicking on a anchor link
		const anchors = document.querySelectorAll('a[href*="#"]:not([href="#"]');
		anchors.forEach(function (anchor) {
			anchor.addEventListener('click', function (event) {
				event.preventDefault();

				// Get target element
				const hash = this.hash;
				const target = document.getElementById(hash.substring(1));

				// Scroll to target element
				if (target){
					window.scrollTo({
						top: target.offsetTop - 61,
						behavior: "smooth"
					});
				}
			});
		});

		// When clicking on a anchor link from a different page
		const hash = window.location.hash;
		if (hash.length > 0) {
			// Scroll top
			window.scrollTo(0, 0);
			setTimeout(function () { scroll(0, 0); }, 1); // Takes care of some browsers issue

			// Get target element
			const target = document.getElementById(hash.substring(1));

			// Scroll to target element
			if (target){
				setTimeout(function () {
					window.scrollTo({
						top: target.offsetTop - 61,
						behavior: "smooth"
					});
				}, 100);
			}
		}		
	}
}